import React from "react";

/**
 * GuestRoute - للصفحات المتاحة للجميع (بدون أي شروط)
 * مثل: صفحة القائمة العامة، صفحة الهبوط، صفحة "من نحن"
 */
const GuestRoute = ({ children }) => {
  return children; // ✅ متاح للجميع
};

export default GuestRoute;